<app-ods-modal [heading]="title" titleId="confirmationDialogTitle">
  <p class="ods-modal__message">{{ message }}</p>

  <ng-container modalActions>
    <ng-container *ngIf="useCustomLayout; else legacyActions">
      <button mat-stroked-button color="primary" (click)="onNoClick()" *ngIf="showNo">{{ cancelText }}</button>
      <button mat-raised-button color="primary" (click)="onYesClick()" cdkFocusInitial>{{ confirmText }}</button>
    </ng-container>

    <ng-template #legacyActions>
      <button mat-stroked-button color="primary" (click)="onNoClick()" cdkFocusInitial *ngIf="showNo">
        {{ cancelText }}
      </button>
      <button mat-raised-button color="primary" (click)="onYesClick()">{{ confirmText }}</button>
    </ng-template>
  </ng-container>
</app-ods-modal>
